































































import { Component, Prop, Vue } from "vue-property-decorator";
import BaseDashboard from "@/modules/dashboard/containers/BaseDashboard.vue";
import DashboardWrapper from "@/modules/dashboard/components/DashboardWrapper.vue";
import { SidebarItem } from "@/modules/dashboard/components/types";
import { SaveStatus, Status } from "@/modules/simulator/store";

@Component({
    inheritAttrs: false,
    components: {
        BaseDashboard,
        DashboardWrapper
    }
})
export default class SimulatorContainer extends Vue {
    @Prop({
        type: String,
        required: true
    })
    public readonly homeUrl!: string;

    @Prop({
        type: String,
        required: true
    })
    public readonly homeUrlTitle!: string;

    @Prop({
        type: Number,
        required: true
    })
    public readonly saveStatus!: SaveStatus;

    @Prop({
        type: Number,
        required: true
    })
    public readonly status!: Status;

    @Prop({
        type: Boolean,
        required: true
    })
    public readonly isValidResults!: boolean;

    public get title(): string {
        return this.$route.meta.title;
    }

    public get sidebarItems(): SidebarItem[] {
        return [
            {
                url: `${this.homeUrl}.simulator.input`,
                className: "simulator-input",
                text: "Dados de entrada"
            },
            {
                url: `${this.homeUrl}.simulator.calculate`,
                className: "simulator-calculate",
                text: "Calcular"
            },
            {
                url: `${this.homeUrl}.simulator.output`,
                className: "simulator-output",
                text: "Resultados"
            }
        ];
    }

    public get statusTooltipMessage(): string {
        switch (this.status) {
            case Status.none:
                return "Nenhuma simulação em andamento.";
            case Status.failed:
                return "Erro durante a simulação.";
            case Status.success:
                if (this.isValidResults) {
                    return "Simulação efetuada com sucesso.";
                }
                return "Resultados inconsistentes.";
            default:
                return "Simulação em andamento.";
        }
    }

    public get SaveStatus() {
        return SaveStatus;
    }

    public get Status() {
        return Status;
    }
}
